<!-- begin::Toggle -->
<!-- ToDo: add loader till user data will occur -->
<div
  *ngIf="user$ | async as _user"
  class="user-trigger-inner d-flex align-items-center"
>
  <div class="d-inline-block text-truncate mw-125px lh-base">
    <span class="text-muted">{{'MENU.WELCOME' | translate}} </span>
    <strong>{{_user.firstName || _user.username}}</strong>
  </div>
  <div class="ms-1 ms-md-2">
    <ng-content></ng-content>
  </div>
</div>
<!-- end::Toggle  -->

